import * as React from 'react'

function SvgPhoneIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.092 5.362L5.682 1 1.086 3.544s-.873 4.09 2.984 8.952c3.857 4.861 10.102 4.498 10.102 4.498L17 12.632l-4.244-2.454-1.724 1.818s-1.492 0-3.227-1.545C6.07 8.906 6.058 6.998 6.058 6.998l2.034-1.636z"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgPhoneIcon
